import FloodEventsManager from '@/components/flood-events/FloodEventsManager';

export const DataHarvestPage = () => {
    return (
        <FloodEventsManager />
    );
}
